import React from "react";
import { motion } from "framer-motion";
import { Card } from "../../components/card/card";
import { Form } from "../../components/form/form";
import config from "../../config/config";
import Icon from "../../components/icon/icon";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export function Contact() {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-6"
    >
      {/* Page Header */}
      <motion.div variants={itemVariants} className="border-b border-slate-200/60 pb-4">
        <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
          Contacto & Soporte Técnico
        </h1>
        <p className="text-xs text-slate-500 font-medium mt-0.5">
          ¿Preguntas sobre el sistema de monitoreo o la calibración de sensores? Escríbenos.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
        {/* Left Hero Card */}
        <motion.div
          variants={itemVariants}
          whileHover={{ y: -4, transition: { duration: 0.2 } }}
          className="lg:col-span-5 relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary via-indigo-700 to-slate-900 text-white p-8 shadow-card flex flex-col justify-between min-h-[480px]"
        >
          {/* Subtle background glow effect */}
          <div className="absolute -right-20 -top-20 w-60 h-60 bg-white/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute -left-20 -bottom-20 w-60 h-60 bg-indigo-500/20 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative z-10">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold bg-white/15 backdrop-blur-md text-white border border-white/20 mb-6">
              <Icon className="text-xs">envelope</Icon> Canal de Atención Directa
            </span>
            <h2 className="text-2xl font-extrabold text-white tracking-tight mb-3">
              Impulsemos la Calidad Ambiental de tu Industria
            </h2>
            <p className="text-indigo-100/80 text-xs leading-relaxed">
              Estamos a tu disposición para consultas técnicas, calibración de sensores MICS-6814 y soporte sobre la plataforma de datos.
            </p>
          </div>

          <div className="relative z-10 space-y-4 pt-8 border-t border-white/10">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center text-white text-sm">
                <Icon>location-dot</Icon>
              </div>
              <div>
                <span className="text-[11px] text-indigo-200 block">Ubicación de Referencia</span>
                <span className="text-xs font-bold text-white">Bogotá D.C., Colombia</span>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center text-white text-sm">
                <Icon>building</Icon>
              </div>
              <div>
                <span className="text-[11px] text-indigo-200 block">Entorno de Prueba</span>
                <span className="text-xs font-bold text-white">Grupo Técnico Basse Ltda</span>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center text-white text-sm">
                <Icon>clock</Icon>
              </div>
              <div>
                <span className="text-[11px] text-indigo-200 block">Horario de Atención</span>
                <span className="text-xs font-bold text-white">Lunes a Viernes • 8:00 AM - 5:00 PM</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Right Form Card */}
        <motion.div variants={itemVariants} className="lg:col-span-7">
          <Card className="p-8 h-full">
            <Form
              title="Envíanos un mensaje"
              fields={config.contactFields}
              change={(fields) =>
                fields
                  .filter(({ value }) => value)
                  .forEach((element) => console.log(`${element.placeholder} : ${element.value}`))
              }
              buttonTitle="Enviar Consulta"
              submit={(fields) => fields.forEach((element) => console.log(element.value))}
            />
          </Card>
        </motion.div>
      </div>
    </motion.div>
  );
}